export enum RouteName {
  ROOT = "root",
  INDEX = "index",

  // Primary view
  SEARCH = "search",
  SEARCH_DETAILS = "search-details",
  PLAN_ROUTE = "plan-route",
  PLAN_TRUCK_ROUTE = "plan-truck-route",

  // Range Spider
  RANGE_SPIDER = "range-spider",
  RANGE_SPIDER_OVERVIEW = "range-spider-overview",

  // Range Spider station
  RANGE_SPIDER_OVERVIEW_STATION_ROOT = "range-spider-overview-station-root",
  RANGE_SPIDER_OVERVIEW_STATION = "range-spider-overview-station",
  RANGE_SPIDER_OVERVIEW_STATION_PRICING_ROOT = "range-spider-overview-station-pricing-root",
  RANGE_SPIDER_OVERVIEW_STATION_PRICING = "range-spider-overview-station-pricing",
  RANGE_SPIDER_OVERVIEW_STATION_CHARGE_CARDS_ROOT = "range-spider-overview-station-charge-cards-root",
  RANGE_SPIDER_OVERVIEW_STATION_CHARGE_CARDS = "range-spider-overview-station-charge-cards",
  RANGE_SPIDER_OVERVIEW_STATION_CHARGE_CARDS_PRICING = "range-spider-overview-station-charge-cards-pricing",

  // More page
  MORE = "more",
  MORE_LEGEND = "more-legend",
  NOT_FOUND = "not-found",

  // Station
  STATION_ROOT = "station-root",
  STATION = "station",
  STATION_SEND_TO_PHONE = "station-send-to-phone",
  STATION_PRICING_ROOT = "station-pricing-root",
  STATION_PRICING = "station-pricing",
  STATION_CHARGE_CARDS_ROOT = "station-charge-cards-root",
  STATION_CHARGE_CARDS = "station-charge-cards",
  STATION_CHARGE_CARDS_PRICING = "station-charge-cards-pricing",

  // Route
  ROUTE_OVERVIEW_ROOT = "route-overview-root",

  // Route details
  ROUTE_OVERVIEW_DETAILS = "route-overview-details",
  ROUTE_OVERVIEW_DETAILS_AMENITY_CHARGE_STOP = "route-overview-details-amenity-charge-stop",
  ROUTE_OVERVIEW_DETAILS_AI_ENHANCED = "route-overview-details-ai-enhanced",
  ROUTE_OVERVIEW_DETAILS_AI_ENHANCED_LOCATION = "route-overview-details-ai-enhanced-location",
  ROUTE_OVERVIEW_DETAILS_SEND_TO_PHONE = "route-overview-details-send-to-phone",

  // Route station
  ROUTE_OVERVIEW_STATION_ROOT = "route-overview-station-root",
  ROUTE_OVERVIEW_STATION = "route-overview-station",
  ROUTE_OVERVIEW_STATION_PRICING_ROOT = "route-overview-station-pricing-root",
  ROUTE_OVERVIEW_STATION_PRICING = "route-overview-station-pricing",
  ROUTE_OVERVIEW_STATION_CHARGE_CARDS_ROOT = "route-overview-station-charge-cards-root",
  ROUTE_OVERVIEW_STATION_CHARGE_CARDS = "route-overview-station-charge-cards",
  ROUTE_OVERVIEW_STATION_CHARGE_CARDS_PRICING = "route-overview-station-charge-cards-pricing",
}

export enum RouteView {
  PRIMARY = "primary",
  PRIMARY_CONTENT = "primary-content",
  SECONDARY_CONTENT = "secondary-content",
  SECONDARY = "secondary",
  RANGE_SPIDER_OVERVIEW = "range-spider-overview",
  MORE = "more",
}
